<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo d-flex align-items-center">
        
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Hero -->
      <b-col lg="8" class="d-none d-lg-flex p-0 auth-hero-wrap">
        <section class="auth-hero-content w-100 h-100 d-flex flex-column justify-content-between">
          <div class="auth-hero-top d-flex align-items-center">
            <img
              src="/assets/logo-96.png"
              alt="Logo"
              class="mr-1"
              style="width: 56px"
            />
            <div>
              <h3 class="mb-0 text-white">PT. BIMA</h3>
              <small class="text-white-70">ERP System</small>
            </div>
          </div>
          <div class="auth-hero-main">
            <h1 class="auth-hero-title">
              Kelola operasional dengan cepat dan terintegrasi.
            </h1>
            <p class="auth-hero-subtitle">
              Pantau stok, penerimaan, distribusi, dan laporan dalam satu
              dashboard terpadu ERP BIMA.
            </p>
            <ul class="auth-hero-points mb-0">
              <li>Monitoring stok realtime lintas gudang.</li>
              <li>Alur penerimaan dan penempatan lebih tertata.</li>
              <li>Data transaksi siap audit dan mudah ditelusuri.</li>
            </ul>
          </div>
          <small class="text-white-70">
            ERP BIMA — Mendukung keputusan operasional harian.
          </small>
        </section>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold mt-3" title-tag="h2">
            Selamat Datang di ERP System
          </b-card-title>
          <b-card-text class="mb-2"> Silakan Login </b-card-text>

          <!-- form -->
          <validation-observer ref="loginForm" #default="{ invalid }">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- email -->
              <b-form-group label="Email" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="email@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <!-- <b-link :to="{name:'auth-forgot-password'}">
                    <small>Forgot Password?</small>
                  </b-link> -->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
                @click.prevent="login"
                class="mb-2"
              >
                {{ loginLabel }}
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      loginLabel: "Login",
      password: null,
      userEmail: null,
      // validation rules
      required,
      email,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then(async (success) => {
        if (success) {
          try {
            this.loginLabel = "Loading...";
            const response = await useJwt.login({
              email: this.userEmail,
              password: this.password,
            });
            let {
              data: userData,
              access: accessMenu,
              type: typeToken,
              tokens: token,
            } = response.data;

            if (!userData.level) {
              this.displayError({
                message: "User tidak terdaftar",
              });

              return false;
            }
            useJwt.setToken({ type: typeToken, token });

            // get role user
            const roles = await this.$store.dispatch("role/getData", {
              level_id: userData.level.id,
            });
            if (!roles) {
              this.displayError({
                message: "User belum memiliki akses",
              });
              return false;
            }
            const myMenus = [];
            accessMenu = accessMenu.filter(item => item?.name != null)
            accessMenu.map((parent) => {
              const payload = {
                title: parent.name,
                icon: parent.icon,
              };

              // parent menu
              if (parent.sub_menu) {
                payload.children = [];
                // loop sub menu
                parent.sub_menu.map((sb) => {
                  const sb_payload = {
                    title: sb.name,
                    icon: "CircleIcon",
                    route: sb.url,
                    url: sb.url,
                  };

                  if (sb.notifikasi && sb.notifikasi.notif > 0) {
                    sb_payload.tag = sb.notifikasi.notif;
                  }

                  payload.children.push(sb_payload);
                });
              } else {
                // link menu
                payload.route = parent.url;
                payload.url = parent.url;
                // get notifikasi if they > 0
                if (parent.notifikasi && parent.notifikasi.notif > 0) {
                  payload.tag = parent.notifikasi.notif;
                }
              }

              myMenus.push(payload);
            });

            // check if user is admin gudang, get his gudang
            const isAdminGudang =
              userData.level &&
              this.GUDANG_KEYS.includes(
                userData.level.nama_level
                  .split(" ")
                  .map((word) => word.toLowerCase())
                  .join("_")
              );
            if (isAdminGudang) {
              const myKaryawanId = userData.karyawan
                ? userData.karyawan.id
                : null;
              const  isSalesUser = userData.level.nama_level
                  .split(" ")
                  .map((word) => word.toLowerCase())
                  .join("_") == "sales"
              const jenis = isSalesUser ? 2 : 1
              const myGudang = await this.$store.dispatch("gudang/getData", {
                karyawan_id: myKaryawanId,
                jenis
              });

              if (!myGudang || myGudang.length < 1) {
                localStorage.clear();
                sessionStorage.clear();
                this.displayError({
                  message: "Akun Gudang belum ditempatkan, hubungi Admin",
                });
                this.loginLabel = "Login";
                return false;
              }

              localStorage.setItem("myGudang", JSON.stringify(myGudang[0]));
            }

            localStorage.setItem("userData", JSON.stringify(userData));
            localStorage.setItem("accessMenu", JSON.stringify(myMenus));
            localStorage.setItem("userRoles", JSON.stringify(roles));
            this.updateAbility(roles);

            if (this.$route.query.to) {
              const path = this.$route.query.to;
              window.location.href = path;
            } else {
              window.location.reload();
            }
          } catch (e) {
            this.loginLabel = "Login";
            this.displayError(e);
            return false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.auth-wrapper.auth-v2 .auth-hero-wrap {
  min-height: 100vh;
  background-image: linear-gradient(
      135deg,
      rgba(40, 48, 70, 0.78),
      rgba(40, 48, 70, 0.55)
    ),
    url("/assets/realistic-bg.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}


.auth-hero-content {
  padding: 2.5rem 3rem;
  color: #fff;
}

.auth-hero-title {
  color: #fff;
  font-size: 2.2rem;
  line-height: 1.2;
  margin-bottom: 1rem;
  font-weight: 700;
  max-width: 700px;
}

.auth-hero-subtitle {
  color: rgba(255, 255, 255, 0.92);
  font-size: 1rem;
  margin-bottom: 1rem;
  max-width: 700px;
}

.auth-hero-points {
  color: rgba(255, 255, 255, 0.95);
  padding-left: 1.1rem;
}

.auth-hero-points li {
  margin-bottom: 0.45rem;
}

.text-white-70 {
  color: rgba(255, 255, 255, 0.78);
}

.dark-layout .auth-wrapper.auth-v2 .auth-hero-wrap {
  background-image: linear-gradient(
      135deg,
      rgba(40, 48, 70, 0.72),
      rgba(40, 48, 70, 0.45)
    ),
    url("/assets/realistic-bg.png");
}
</style>
